import BaseModel from '../core/BaseModel'
export default class GroupModel extends BaseModel {

    constructor() {
        super({ 
                name: "group",
                tableName: 'group',
                label: "Danh sách phân quyền",
                display_key: 'name',
                default_order: { key: 'ordinal', direction: 'asc' } ,
            },
            {
            stt: {
                name: "stt",
                label: "STT",
                type: "Computed",
                computed: (data, index) => {
                    data.stt = index + 1;
                },
                // display: { list: true, add: false, edit: false }
            },
            id: { 
                name: 'id', 
                type: "Bigint",
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            name: {
                name: 'name',
                type: "String",
                label: 'Tên nhóm quyền',
                filter: {type: 'input', match: 'contains'},
                // display: false
            },
            farm_name:{
                name: 'farm_name',
                type: "String",
                label: 'Trang trại',
                computed: (data) => {
                    data.farm_name = "";
                }
            },
            group_users: {
                name: 'group_users',
                label: 'Đang áp dụng',
                type: "CustomUrl",
                class: "center",
                custom: "String",
                refs: 'group_users {uid active}',
            },
            created_at: {
                name: 'created_at',
                type: "Datetime",
                class: "center",
                label: 'Ngày tạo',
                filter: {
                    type: "DateRange", match: "contrains",
                },
            },
            is_farm: {
                name: 'is_farm',
                display: false
            },
            farm_id: {
                name: 'farm_id',
                display: false
            },
            group_roles: {
                refs: `group_roles {
                        id
                        role_id
                    }`,
                display: false
            },
            farm: {
                refs: 'farm {id name}',
                display: false
            }
        },)
    }

}
